
<template>
  <div>
    <label class="text-sm opacity-75">{{ $te('filters.' + filter.title + '.title')?$t('filters.' + filter.title + '.title'):filter.title }}</label>
    <flat-pickr v-if="datepickerConfig"
                        class="w-full"
                        :value="selectedPeriod"
                        :config="datepickerConfig"
                        @on-close="onChangeSelectedPeriod"/>
  </div>
</template>

<script>
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'sm-hateoas-filter-date-picker',
  components: {
    flatPickr
  },
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          format: null,
          minView: null,
          maxView: null,
          dates: []
        };
      }
    }
  },
  data () {
    return {
      selectedModel: null,
      selected: null,
      dates: null,
      disabledDates: {},
      datepickerConfig: null,
      selectedPeriod: null
    };
  },
  mounted () {
    let selectedDateFrom = new Date();
    let selectedDateTo = new Date();

    if (this.filter.dates) {
      selectedDateFrom = this.filter.dates[0].date;
      selectedDateTo = this.filter.dates.length > 1 ? this.filter.dates[1].date : this.filter.dates[0].date;
    }

    this.selectedPeriod = [moment(selectedDateFrom).endOf('day').toDate(), moment(selectedDateTo).endOf('day').toDate()].sort((a, b) => a - b);
    this.datepickerConfig = {
      mode: 'range',
      dateFormat: 'M j, Y',
      wrap: true,
      defaultDates: this.selectedPeriod.slice(),
      enable: [
        {
          from: moment(this.filter.minDate).startOf('day').toDate(),
          to: moment(this.filter.maxDate).endOf('day').toDate()
        }
      ]
    };

    this.onChangeSelectedPeriod(this.selectedPeriod);

  },
  methods: {
    isSelected (date) {
      return this.selected.indexOf(date.value) >= 0;
    },
    handleSelected (date) {
      this.selected = moment(date).endOf('month').format('YYYY-MM-DD');
      this.$emit('change', this.selected);
    },
    dateFormatter (date) {
      return moment(date).endOf('month').format(this.filter.format);
    },
    customPredictor (date) {
      const formatDate = moment(date).endOf('month').format('YYYY-MM-DD');
      return !this.dates.has(formatDate);
    },
    onChangeSelectedPeriod (period) {
      this.selectedPeriod = period;
      const formattedPeriod = period.map(p => moment(p).format('YYYY-MM-DD'));
      this.selected = formattedPeriod;
      const toDate = (formattedPeriod[1] && formattedPeriod[0] !== formattedPeriod[1]) ? `|${formattedPeriod[1]}` : '';
      this.$emit('change', formattedPeriod[0] + toDate);
    }
  }
};
</script>
